import React, { useState } from "react";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import TreeItemTop from "../CommonComponents/TreeItemTop";
import zips from "../../../utils/zips";

export default function TreeContainer({ data, selected, setSelected }) {
  const [isOpenParent, setIsOpenParent] = useState([]);
  const [isOpenNestedParent, setIsOpenNestedParent] = useState([]);

  const removeTargetItem = (target, array) => {
    const elementsIndexToRemove = array.indexOf(target);
    elementsIndexToRemove !== -1 && array.splice(elementsIndexToRemove, 1);
  };

  const uncheckParentNodeFirstLvl = (id, array) => {
    const selectedNestedNode = zips.find(
      (item) => item.cityWithStateAbbr === id
    );
    const groupIdForChecking = selectedNestedNode.ST;
    const targetGroup = data.find((group) => group.id === groupIdForChecking);

    const nestedItemsIsSelected = targetGroup.children.some((item) =>
      array.includes(item.id)
    );

    !nestedItemsIsSelected && removeTargetItem(groupIdForChecking, array);
  };

  const uncheckParentNodeSecondLvl = (id, array) => {
    const selectedNestedNode = zips.find((item) => item.zip === id);
    const currentState = selectedNestedNode.ST;
    const groupIdForChecking = selectedNestedNode.cityWithStateAbbr;
    const targetStateGroup = data.find(
      (stateGroup) => stateGroup.id === currentState
    );

    const targetGroup = targetStateGroup.children.find(
      (group) => group.id === groupIdForChecking
    );
    const nestedSubGroupItemsIsSelected = targetGroup.children.some((item) =>
      array.includes(item.id)
    );

    !nestedSubGroupItemsIsSelected &&
      removeTargetItem(groupIdForChecking, array);

    const nestedGroupItemsIsSelected = targetStateGroup.children.some((item) =>
      array.includes(item.id)
    );

    !nestedGroupItemsIsSelected && removeTargetItem(currentState, array);
    const elementsIndexToRemove = array.indexOf(currentState);
    elementsIndexToRemove !== -1 && array.splice(elementsIndexToRemove, 1);
  };

  const getSelectedNode = (node) => {
    const idsList = [];
    //case for state branch
    if (node.id.length === 2) {
      idsList.push(node.id);
      node.children.forEach((item) => {
        if (Array.isArray(item.children)) {
          item.children.forEach((item) => idsList.push(item.id));
        }
        idsList.push(item.id);
      });

      return idsList;
    }
    //case for bottom item
    if (!isNaN(Number(node.id))) {
      return Object.values(zips.find((item) => item.zip === node.id));
    }
    //case for middle item (nested parent)
    idsList.push(node.id.slice(node.id.length - 2));
    idsList.push(node.id);
    node.children.forEach((item) => idsList.push(item.id));
    return idsList;
  };

  const getOnChange = (checked, nodes) => {
    let array = null;
    const allNode = getSelectedNode(nodes);

    if (checked) {
      array = [...selected, ...allNode];
    } else {
      array = selected.filter((value) => !allNode.includes(value));

      // Conditions for run funcs for getting nodesID for uncheck, if them empty
      if (
        // Condition for middle lvl, for zips
        Array.isArray(nodes.children) &&
        nodes.id.length > 2
      ) {
        uncheckParentNodeFirstLvl(nodes.id, array);
      } else if (
        // Condition for last lvl, for zips
        !Array.isArray(nodes.children)
      ) {
        uncheckParentNodeSecondLvl(nodes.id, array);
      }
    }

    setSelected(array);
  };

  return (
    <TreeView
      expanded={[...isOpenParent, ...isOpenNestedParent]}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {data.map((item) => (
        <TreeItemTop
          key={item.id}
          nodes={item}
          getOnChange={getOnChange}
          selected={selected}
          isOpenParent={isOpenParent}
          setIsOpenParent={setIsOpenParent}
          isOpenNestedParent={isOpenNestedParent}
          setIsOpenNestedParent={setIsOpenNestedParent}
        />
      ))}
    </TreeView>
  );
}
